import React from 'react';
import { useSelector } from 'react-redux';
import { isVietnam } from 'Util/DataUtils';
import SidebarKo from './SidebarKo';
import SidebarVi from './SidebarVi';

const SidebarContent = () => {
  const { user } = useSelector(state => state.authUser);

  return isVietnam(user) ? <SidebarVi /> : <SidebarKo />;
};

export default SidebarContent;
